<template lang="pug">
  div
    a.cart-button(href="/cart")
      .cart-icon
        span.badge(v-if="itemCount") {{ itemCount }}
    div.icon-text カート
</template>

<script>
import CustomerStore from '../../../stores/CustomerStore'
export default {
  name: 'CartButton',
  /**
   * data
   * @returns {{msg: string}}
   */
  data () {
    return {
    }
  },
  /**
   * mounted
   */
  mounted () {
  },
  computed: {
    /**
     * カートに入れている商品数を返す
     * @return number カートの商品数
     */
    itemCount () {
      return CustomerStore.state.user.itemCount
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../assets/scss/bootstrap/bootstrap.scss';

.cart-button {
  display: block;
  background: url('../../../../static/images/common/header_cart.gif') no-repeat;
  background-size: 27px 27px;
  background-position: center 8px;
  color: #f15e4b;
  height: 42px;
  position: relative;
}
.icon-text {
  font-family: “HiraginoSans-W5”, sans-serif;
  text-align: center;
  font-size: 8px;
  text-decoration: none;
  letter-spacing: -0.1em;
  color: #f15e4b;
}
.badge {
  display: block;
  background-color: #f15e4b;
  height: 17px;
  min-width: 17px;
  padding: 4px;
  color: #fff;
  font-size: 9px;
  text-align: center;
  line-height: 10px;
  position: absolute;
  top: 3px;
  left: 50%;
  border: 0px;
  border-radius: 9px;
  margin-left: 8px;}
</style>



// WEBPACK FOOTER //
// src/components/sp/common/CartButton.vue